import { render, staticRenderFns } from "./data69.vue?vue&type=template&id=0a74f036&scoped=true&"
import script from "./data69.vue?vue&type=script&lang=js&"
export * from "./data69.vue?vue&type=script&lang=js&"
import style1 from "./data69.vue?vue&type=style&index=1&id=0a74f036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74f036",
  null
  
)

export default component.exports